export default __webpack_public_path__ + "static/media/user.412d7729.svg";